import { render, staticRenderFns } from "./RemoveWorkspace.vue?vue&type=template&id=0e3420a0&scoped=true"
import script from "./RemoveWorkspace.vue?vue&type=script&lang=js"
export * from "./RemoveWorkspace.vue?vue&type=script&lang=js"
import style0 from "./RemoveWorkspace.vue?vue&type=style&index=0&id=0e3420a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3420a0",
  null
  
)

export default component.exports